<template>
  <cTable ref="form" :methods="methods" :form="form"> </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { fordealInWarehouse } from "@/api/order/inbound_fordeal";
export default {
  name: "inboundFordeal",
  components: {
    cTable
  },

  data() {
    return {
      methods: { fordealInWarehouse },
      form: {
        config: {
          modalBind: {
            width: 600
          },
          formBind: {
            labelWidth: 140,
            style: {
              width: "60%",
              margin: "50px auto"
            }
          },
          rowBind: {
            gutter: 13,
            style: {
              marginBottom: "20px"
            }
          },
          rules: {
            warehouse_id: [
              {
                required: true,
                message: "cannot be empty",
                trigger: "change",
                type: "number"
              }
            ],
            to_country: [
              {
                required: true,
                message: "cannot be empty",
                trigger: "change"
              }
            ],
            packing_number: [
              {
                required: true,
                message: "cannot be empty",
                trigger: "blur"
              }
            ],
            time: [
              {
                required: true,
                type: "date",
                message: "cannot be empty",
                trigger: "change"
              }
            ]
          }
        },
        grid: [
          {
            warehouse_id: 24
          },
          {
            time: 24
          },
          {
            packing_number: 24
          },
          {
            to_country: 24
          },
          {
            file: 24
          }
        ],
        fields: [
          {
            key: "warehouse_id",
            name: () => this.$t("warehouseName1"),
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName1");
            },
            options: [
              {
                label: "佛山仓",
                value: 65
              },
              {
                label: "深圳仓",
                value: 96
              }
            ]
          },
          {
            key: "to_country",
            name: () => this.$t("allow_arrive"),
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("allow_arrive");
            },
            options: [
              {
                label: "阿联酋",
                value: "AE"
              },
              {
                label: "沙特",
                value: "SA"
              }
            ]
          },
          {
            key: "time",
            name: () => this.$t("inboundTime"),
            component: "DatePicker",
            disabledDate: true,
            bind: {
              type: "datetime"
            },
            placeholder() {
              return this.$t("select") + this.$t("inboundTime");
            },
            methods: {
              format({ value }) {
                return value ? this.format.zoneTime(value) : "";
              }
            }
          },
          {
            key: "packing_number",
            name: () => this.$t("packing_number"),
            component: "Input",
            placeholder() {
              return this.$t("enter") + this.$t("packing_number");
            }
          },
          {
            key: "file",
            name: () => this.$t("Excel doc"),
            component: "Upload",
            bind: {
              fileName: true,
              isButton: true,
              type: "select",
              accept: ".xlsx,.xls"
            },
            methods: {
              beforeUpload({ file, row }) {
                row["file"] = file;
                return false;
              }
            }
          }
        ],
        buttons: [
          {
            name: () => this.$t("order_submit"),
            bind: {
              style: {
                width: "100px",
                marginTop: "100px"
              },
              type: "primary",
              icon: "md-add"
            },
            isSub: true,
            methods: {
              click({ formData }) {
                let data = new FormData();
                for (const key in formData) {
                  if (key === "time") {
                    data.append(
                      key,
                      formData[key]
                        ? this.$page.format.timeFormat(
                            formData[key],
                            "YYYY-MM-DD HH:mm:ss"
                          )
                        : ""
                    );
                  } else {
                    data.append(key, formData[key]);
                  }
                }
                console.log(data);
                this.$page
                  .handleRequestMethods("fordealInWarehouse", data)
                  .then(() => {
                    this.$refs["form"].resetFields();
                  });
              }
            }
          }
        ]
      }
    };
  }
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
